import React from 'react';
import { defaultGetter, defaultSetter } from 'rewire-common';
import { settingsDialogModel } from './SettingsDialog';
import DataMutations from '../graphql/Mutations';
import DataQueries from '../graphql/Queries';
import APISettingsView from './APISettingsView';
import { notifications } from '../ui/Notifications';
import SettingsModel from './SettingsModel';
import { arraySearch, error, Form, IFormContext, validator } from 'rewire-ui';
import CopyTextToClipboard from './CopyTextToClipboard';
import mainPageModel from '../main-navigation/MainPageModel';

const APISchema = `
  id
  name
  tz
  country
  state
  right
`;

export default class APISettingsModel extends SettingsModel {
  constructor() {
    super(
      'API',
      undefined,
      undefined,
      // ,
      [
        // { label: 'Key', get: defaultGetter('id'), set: defaultSetter('id') },
        { label: 'Country', get: defaultGetter('country'), set: defaultSetter('country') },
        { label: 'State', get: defaultGetter('state'), set: defaultSetter('state') },
        { label: 'Timezone', get: defaultGetter('tz'), set: defaultSetter('tz') },
        { label: 'Security Right', get: defaultGetter('right'), set: defaultSetter('right') },
        // { label: 'Access', get: (v: any) => permissionsToString(this, v), set: (items: any, value: any) => {}},
      ],
      // undefined,
      // DataMutations.updateUsers
    );
    // this.title = 'Generate API Key';
    // this.SettingsView = APISettingsItemsPanelView;
    this.SettingsView = APISettingsView;
  }

  get access() {
    return mainPageModel.apiAccess;
  }

  protected _handleOnSubmit() {
    super._handleOnSubmit();
    // this._reload(this);
  }

  canAddItem() {
    return true;
  }

  canDeleteItem(): boolean {
    if (!this.selectedItem) {
      return false;
    }

    return true;
  }

  deleteItem = async () => {
    if (!this.selectedItem) return;
    const tokenName = this.selectedItem?.name;
    const form = Form.create(
      (form: IFormContext) => ({
        confirm: form
          .string()
          .label('Token Name')
          .validators('required', validator('==', tokenName, error('Token name does not match.')))
          .placeholder(`enter ${tokenName} to delete the Api token`)
          .autoFocus(),
      }),
      {},
      { validateOnUpdate: true, updateOnChange: true },
    );
    form.validateForm(); // Prime the form with validation errors.

    if (
      !(
        (await settingsDialogModel.load({
          minHeight: '176px',
          title: `Delete Api token ${tokenName}?`,
          form,
          buttons: ['ok', 'cancel'],
          defaultButton: 'ok',
        })) === 'ok'
      )
    )
      return;

    const result = await DataMutations.removeApiKey(this.selectedItem.name);
    if (result) {
      notifications.success(`API Token ${this.selectedItem.name} successfully removed`);
      this._load();
    } else {
      notifications.error(`API Token ${this.selectedItem.name} removal failed`);
    }
  };

  addItem = async (_item?: any) => {
    const tokenNameForm = Form.create(
      (form: IFormContext) => ({
        tokenName: form
          .string()
          .label('Token Name')
          .validators('required')
          .placeholder('enter a name that describes this token')
          .autoFocus(),
        tokenRight: form
          .select(arraySearch(['write', 'read']))
          .validators('required')
          .placeholder('read or write access?')
          .label('access'),
      }),
      { tokenRight: 'write' },
      { validateOnUpdate: true, updateOnChange: true },
    );
    tokenNameForm.validateForm();

    const shouldGenerate =
      (await settingsDialogModel.load({
        minHeight: '295px',
        form: tokenNameForm,
        title: 'Generate Api token',
        buttons: ['ok', 'cancel'],
        defaultButton: 'ok',
      })) === 'ok';
    if (!shouldGenerate) return;
    const tokenName = tokenNameForm.field.tokenName.value;
    const tokenRight = tokenNameForm.field.tokenRight.value ?? 'write';
    if (!tokenName) return;

    const apiToken = await DataMutations.generateApiKey(tokenName, tokenRight);
    if (typeof apiToken !== 'string') return;
    // const apiToken = 'odfslfdslfksflsdk';

    const successForm = Form.create(
      (form: IFormContext) => ({
        successMessage: form.custom(() => (
          <span>{`For security reasons, the full Api token is shown only once. You'll need to copy it somewhere safe before continuing.`}</span>
        )),
        token: form.custom(() => <CopyTextToClipboard value={apiToken} label="apiKey" />),
      }),
      { successMessage: '' },
      { validateOnUpdate: true, updateOnChange: true },
    );
    await settingsDialogModel.load({
      defaultWidth: 'sm',
      minWidth: '692px',
      minHeight: '340px',
      title: `Api token successfully generated for ${tokenName}`,
      form: successForm,
      buttons: ['close'],
    });
    this._load();
  };

  protected async _load(_filter?: { search?: string }) {
    const results = await DataQueries.getApiKeys(APISchema);
    this.setItems(results);
    this.select(undefined);
    return { totalCount: results.length, data: results, cursor: '100' };
  }
}
